import classNames from 'classnames';
import { ReactNode } from 'react';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './TotalCard.scss';

interface ITotalCardProps {
  label?: ReactNode;
  value?: ReactNode;
  variant?: BUTTON_VARIANT;
  onClick?: () => void;
}

const TotalCard = ({
  label,
  value,
  variant = BUTTON_VARIANT.default,
  onClick,
}: ITotalCardProps) => {
  const className = classNames(['total-card', BUTTON_VARIANT[variant]], {
    onClick,
  });
  return (
    <div className={className} onClick={onClick}>
      <div className='total-card-label'>{label} </div>
      <div className='total-card-value'>{value}</div>
    </div>
  );
};

export default TotalCard;
